/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { CreateNoteButton } from '@/components/buttons/viewHeaderButtons/CreateNoteButton';
import { CreateTaskButton } from '@/components/buttons/viewHeaderButtons/CreateTaskButton';
import { TabView } from '@/components/layouts/TabView';
import { useLocation } from 'react-router-dom';
import { getDebtorTabs } from 'app/tabs';
import { getPipelineIcon } from '@/utils/constants';
import { EditPolicyTransactionButton } from '@/components/buttons/viewHeaderButtons/EditPolicyTransactionsButton';
import WorkspaceContextProvider from '@/context/WorkspaceContext';

export const DebtorTabView = () => {
	const theme = useTheme();
	const location = useLocation();

	const { dealRow, dealId } = useObjectContext();

	const pipelineId = dealRow?.pipeline;

	const headerComponents = useMemo(
		() => ({
			notes: CreateNoteButton,
			tasks: CreateTaskButton,
			'': EditPolicyTransactionButton,
		}),
		[],
	);

	const tabs = useMemo(() => {
		const pathname = location.pathname.split(`/${dealId}`);
		const debtorTabs = getDebtorTabs(pathname[0]).map((tab) => {
			return {
				...tab,
				HeaderComponent: headerComponents[tab.value ?? ''],
			};
		});
		return debtorTabs;
	}, [headerComponents]);

	const activeTabs = useMemo(() => tabs.filter((tab) => tab.showComponent), [tabs]);

	return (
		<WorkspaceContextProvider>
			<TabView
				objectType='debtor'
				tabs={activeTabs}
				icon={getPipelineIcon(
					pipelineId,
					'55px',
					theme.palette.mode === 'dark' ? { bgColor: 'transparent' } : undefined,
				)}
			/>
		</WorkspaceContextProvider>
	);
};
